import { render } from "./OrderDetailsTabContent.vue?vue&type=template&id=087ec917"
import script from "./OrderDetailsTabContent.vue?vue&type=script&lang=js"
export * from "./OrderDetailsTabContent.vue?vue&type=script&lang=js"

import "./OrderDetailsTabContent.vue?vue&type=style&index=0&id=087ec917&lang=less"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__